<template>
  <div class="buttons-flex z-index-2 w-370 margin-auto">
    <span v-if="['add-users', 'confirm-users'].indexOf(currentStep) !== -1"></span>
    <div class="buttons-flex w-370 margin-auto" v-else-if="currentStep === 'confirm'">
      <button type="button" class="button z-index-2 default flex-1 mr-10" @click="back">戻る</button>

      <button v-if="meetingCategory === 1"
        type="button"
        class="button z-index-2 success flex-1"
        @click="next"
      >予約申請する</button>

      <button v-else type="button" class="button z-index-2 success flex-1" @click="next">確定する</button>
    </div>
    <div v-else-if="currentStep === 'last-step'" class="flex-1 text-center">
      <button type="button" class="button z-index-2 default" @click="next">予約一覧に戻る</button>
    </div>
    <template v-else>
      <button v-if="currentStep !== 'select-category'"
        type="button"
        @click="back"
        class="button z-index-2 default medium mt-40 flex-1 mr-10"
      >戻る</button>

      <button type="button"
        @click="next"
        class="button z-index-2 success medium mt-40 flex-1"
        :class="{disabled: disableNextStep}"
        :disabled="disableNextStep"
      >次へ</button>

    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    currentStep: {type: String, required: true},
    steps: {type: Array, required: true},
    meetingCategory: {type: Number, default: 1},
    selectedPharmacy: {type: Object, required: false},
    meeting: {type: Object, required: false},
    disableNextStep: { type: Boolean, required: false, default: false }
  },
  methods: {
    next () {
      if (this.disableNextStep) return
      if(this.$route.name === 'meetings.edit' && this.currentStep === 'add-pharmacies') {
        if (this.meeting.pharmacy.id !== this.selectedPharmacy.id) {
          
          this.$confirm('予約済みの時間も変更しなければなりません。本当に別の薬局を選択しますか？', '', {
          confirmButtonText: '次へ',
          cancelButtonText: 'やめる',
          type: 'warning'
          }).then(() => {
            const index = _.findIndex(this.steps, n => n === this.currentStep)
            this.$emit('changeStep', this.steps[index + 1])
          })
        } else {
          const index = _.findIndex(this.steps, n => n === this.currentStep)
          this.$emit('changeStep', this.steps[index + 1])
        }
      } else {
          const index = _.findIndex(this.steps, n => n === this.currentStep)
          this.$emit('changeStep', this.steps[index + 1])
      }
    },
    back () {
      const index = _.findIndex(this.steps, n => n === this.currentStep)
      this.$emit('changeStep', this.steps[index - 1], true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/Buttons.vue